import React, { useState } from 'react';
import './Auth.scss';
import { validatePassword, generateAuthToken, setAuthToken } from '../../utils/auth.js';

const Auth = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // 비밀번호 검증 로직
      const isValid = await validatePassword(password);
      
      if (isValid) {
        // 인증 성공 시 세션 스토리지에 토큰 저장
        const token = generateAuthToken();
        setAuthToken(token);
        onAuthenticated();
      } else {
        setError('비밀번호가 올바르지 않습니다.');
      }
    } catch (err) {
      setError('인증 중 오류가 발생했습니다.');
      console.error('Auth error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>EDC 관리자</h1>
          <p>관리자 페이지에 접근하려면 비밀번호를 입력하세요</p>
        </div>
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력하세요"
              required
              disabled={isLoading}
              className={error ? 'error' : ''}
            />
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <button 
            type="submit" 
            disabled={isLoading || !password.trim()}
            className="auth-button"
          >
            {isLoading ? '확인 중...' : '로그인'}
          </button>
        </form>
        
        <div className="auth-footer">
          <small>보안을 위해 세션 기반 인증을 사용합니다</small>
        </div>
      </div>
    </div>
  );
};

export default Auth;
